<template lang="pug">
  .company-card
    el-row(type="flex")
      el-col(:span="10")
        img(:src="company.img")
      el-col(:span="14")
        .company-header
          el-row(type="flex")
            .tags
              .main-tag
                el-tag(color="black") {{ company.tag.toUpperCase() }}
              .market-cap
               el-tag(color="gray") ${{ company.marketCap }}M
            .commodities-region
              .commodities
                div(v-for="(commodity, index) in company.commodities")
                  div(v-if="index != company.commodities.length -1") {{ commodity }},&nbsp
                  div(v-else) {{ commodity }}
              .seperator |
              .region {{ company.region }}
            .heart(@click="handleHeartClick")
              font-awesome-icon(:icon="['fas', 'heart']" v-if="company.heart")
              font-awesome-icon(:icon="['far', 'heart']" v-else)
          el-row(type="flex")
            .company-name {{ company.companyName }}
          el-row(type="flex")
            .stock-row
              | {{ company.listing.ticker }}
              | {{ company.listing.exchange }}
              | {{ company.sharePrice.latest.toFixed(2) }}
              font-awesome-icon(:icon="['fas', 'caret-up']" v-if="company.sharePrice.change>0", color="green")
              font-awesome-icon(:icon="['fas', 'caret-down']" v-else, color="red")
              | {{ company.sharePrice.change.toFixed(2) }}
              | ({{ company.sharePrice.changePercent.toFixed(2) }}%)
          el-row
            .updates
              .update-title Recent Updates
              .update-items
                li(v-for="update in company.recentUpdates") {{update}}

    el-divider
</template>

<script>
export default {
  name: 'companyCard',
  props: ['company'],
  data: function () {
    return {
      index: 0
    }
  },
  methods: {
    handleHeartClick (event) {
      this.company.heart = !this.company.heart
    }
  }
}
</script>

<style scoped>
.company-card {
  font-family: Gilroy;
  width: 100%;
}

.company-header {
  width: 100%;
}

.tags {
  padding-right: 8px;
  padding-left: 8px;
  display: flex;
}

.tags .market-cap {
  padding-left: 5px;
}

.commodities-region {
  display: flex;
  font-size: 13px;
  color: #000000;
  letter-spacing: -0.08px;
  height: 18px;
  line-height: 18px;
}

.commodities {
  display: flex;
  padding-right: 10px;
}

.region {
  padding-left: 10px;
}

.heart {
  position: absolute;
  right: 0px;
}

.heart svg {
  height: 26.14px;
  width: 31.85px;
}

.el-tag {
  height: 18px;
  color: #FFFFFF;
  font-size: 11.88px;
  font-weight: 600;
  letter-spacing: 0.68px;
  line-height: 18px;
  padding-right: 5px;
  padding-left: 5px;
}

.company-name {
  color: #000000;
  font-family: Gilroy;
  font-size: 32px;
  letter-spacing: -0.77px;
  padding-left: 8px;
  padding-top: 15px;
}

.stock-row {
  padding-left: 8px;
  color: #000000;
  font-family: Gilroy;
  font-size: 13px;
}

.updates {
  padding-left: 8px;
  padding-top: 15px;
  color: #6B6B6B;
}

.updates .update-title {
  font-weight: 600;
  font-size: 16px;
}

.updates .update-items {
  padding-top: 3px;
  font-size: 13px;
  line-height: 18px;
}
</style>
